import { Component, OnInit, Input } from '@angular/core';
import { CarrierService } from 'app/services/carrier.service';
import { AuthWebService } from 'app/services/authweb.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { environment } from 'environments/environment';
import { CorspdcService } from 'app/services/corspdc.service';
import { CarriertransactionService } from 'app/services/carriertransaction.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import {CarrierAccountService} from '../../../services/carrier-account.service';
import {ToastNotificationService} from '../../../shared/toast-notification/toast-notification.service';
var jsPDF = require('jspdf');
require('jspdf-autotable');

declare var printJS: any;
@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.css']
})
export class InvoiceComponent implements OnInit {

  invoicedetails: any = {};
  @Input() dataCntrl: any;
  isLoading: boolean = false;
  isEmpty: boolean = false;
  user: any = {};
  page = 1
  count: number = 0;

  debtoraccount: any = {};
  referencenumber : string;
  carrierid: string;
  person_id:string;
  accountnumber: string;
  message = "Submitting your request, please wait...";

  constructor(private carrierService: CarrierService, private authWebService: AuthWebService,private router:Router, public transData: CarriertransactionService, public utility: UtilityServiceService,
              private toaster:ToastrService,private toastService:ToastNotificationService, public datepipe:DatePipe,private carrierAccountService:CarrierAccountService, private route: ActivatedRoute, private crspdService:CorspdcService) {
    this.user = (this.authWebService.userData) ? this.authWebService.userData.User:null;
  }
  ngOnInit() {

    this.utility.showstatementfooter = true;
    this.route.paramMap.subscribe(params => {

      this.accountnumber = params.get("id");
      //console.log(this.accountnumber);
      this.referencenumber = params.get('referencenumber');
      //console.log(this.referencenumber);
      this.carrierid = params.get('carrierid');
      //console.log(this.referencenumber);

    })

    this.loadinvoice(this.referencenumber);
    this.getDebtorAccount(this.accountnumber);
    this. getCarrier();

  }

  loadinvoice(invoicenumber: string)
  {

    this.isLoading = true;
    // //console.log('user.ID = ', this.user.Id);
    this.carrierService.getInvoice(invoicenumber).subscribe((result:any) => {
      this.invoicedetails = result;
      this.count = result.Count;
      this.isEmpty = (this.count == 0) ? true : false;
      console.dir(this.invoicedetails);
      this.isLoading = false;
      this.transData.invoicedetails = this.invoicedetails;
      this.transData.screen = "invoice";
      this.transData.accountnumber = this.accountnumber;
      this.transData.carrierid = this.carrierid;
      this.transData.referencenumber = this.referencenumber;

    }, error => {
      this.isLoading = false;
      this.isEmpty = true;
      //console.log('Error occured: ' + error);

    })

  }

  getDebtorAccount(custcode:string)
  {
    this.carrierService.getDebtorAccount(custcode).subscribe((result:any) => {

      this.debtoraccount = result;
      this.count = result.Count;
      //console.log(this.count);
      console.dir(this.debtoraccount);
      this.transData.debtoraccount = this.debtoraccount;
    }, error => {
      //console.log('Error occured: ' + error);
    })

  }
  onBack() {
    this.router.navigate([
      "carrier/statement/" + this.accountnumber + "/" + this.carrierid,
    ]);
  }
  downloadInvoice(){
    this.isLoading = true;
    this.carrierAccountService.downloadInvoice(this.referencenumber, this.debtoraccount.customer_code).subscribe((x: Blob) => {
      const url = window.URL.createObjectURL(x);
      printJS({ printable: url, type: 'pdf', showModal: true, modalMessage: 'Processing your request, please wait...' });
      // obj.status_id = 75;
      this.isLoading = false;
      this.ngOnInit();
    }, error => {
      console.log(error);
      this.isLoading = false;
      return this.toastService.error('An error occurred when trying to download the invoice, please try again or contact the system admin for help', 'error!')
    });
  }
  getCarrier(){
    this.carrierService.carrierPersonByuserId(Number(this.user.Id)).subscribe((result:any) => {
      this.person_id = result.person_id;
      this.transData.personid = this.person_id;
      //console.log(result);
    }, error => {
      //console.log(error);
    });
  }

  emailInvoice()
  {

    this.carrierAccountService.downloadInvoice(this.referencenumber, this.debtoraccount.customer_code).subscribe((x: Blob) => {
      this.blobToBase64(x)
          .then((base64data) => {
            this.sendConfirmMail(base64data);
            console.log(base64data);
          })
          .catch((error) => {
            console.error(error);
          });
      this.ngOnInit();
    }, error => {
      console.log(error);
      return this.toastService.error('An error occurred when trying to print the permit, please try again or contact the system admin for help', 'error!')
    });
  }
  sendConfirmMail(pdfDoc){
    let payload:any = new Object;
    payload.id= 0;
    payload.carrier_id=this.carrierid;
    payload.from_person_id= this.person_id;
    payload.app_id_permit_type_code= null;
    payload.carrierName= null;
    payload.person_from= this.person_id;
    payload.application_id=null;
    payload.permit_num= null;
    payload.document_id1=null;
    payload.document_id2=null;
    payload.document_id3=null;
    payload.corspdc_type_ind=1;
    payload.send_receive_ind=1;
    payload.comm_type_ind=1;
    payload.subject= `CROSS EASY INVOICE ${this.referencenumber}`;
    payload.body_text='Please attached invoice document for your Cross Easy Account';
    payload.note=null;
    payload.num_bookmarks=1;
    payload.bookmark1_value=null;
    payload.bookmark2_value=null;
    payload.bookmark3_value=null;
    payload.bookmark4_value=null;
    payload.bookmark5_value=null;
    payload.bookmark6_value=null;
    payload.date_to_send= new Date();
    payload.date_sent= new Date();
    payload.date_created=new Date();
    payload.date_modified=new Date();
    payload.user_created=new Date();
    payload.user_modified=new Date();
    payload.send_rcvd= null;
    payload.comm_type= null;
    payload.hasDoc= true;
    payload.attachment= pdfDoc;
    // payload.correspondence_person= ;
    payload.file_name='CrossEasy Invoice';
    //console.log(payload);
    this.crspdService.sendMail(payload).subscribe(res=>{
      console.log("Payload",payload);
      this.toastService.success(`Your statement was successfully emailed.`,'Success');
      this.isLoading = false;
    }, error => {
      console.log(error);
      this.toastService.error(`An error occured`,'Error');
      this.isLoading = false;
    })
  }
  blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = () => {
        const base64data = reader.result.toString().split(',')[1];
        resolve(base64data);
      };
      reader.onerror = (error) => {
        reject(error);
      };
    });
  }

}
